var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 27,
    height: 27,
    rx: 13.5,
    stroke: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20635_77348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89012 20.7727C7.92791 20.8534 7.98794 20.9217 8.06316 20.9695C8.13838 21.0173 8.22567 21.0427 8.3148 21.0427C9.66012 21.0427 10.7982 20.7155 12.0911 19.9533C12.7182 20.0527 13.9567 20.1755 14.5004 20.1755C18.6048 20.1755 21.9432 17.4352 21.9432 14.0658C21.9432 10.6964 18.6048 7.95703 14.5004 7.95703C10.3961 7.95703 7.05762 10.6964 7.05762 14.0658C7.05762 15.6539 7.82355 17.1886 9.17168 18.3258C8.86051 19.0291 8.45111 19.6847 7.95574 20.273C7.83949 20.4136 7.81324 20.6086 7.89012 20.7727ZM7.99512 14.0658C7.99512 11.2139 10.9136 8.89359 14.5004 8.89359C18.0873 8.89359 21.0057 11.2139 21.0057 14.0658C21.0057 16.9177 18.0873 19.238 14.5004 19.238C13.9623 19.238 12.5617 19.0936 12.0882 19.0017C11.9737 18.9812 11.8556 19.0025 11.7554 19.0617C10.8817 19.5961 10.1195 19.9017 9.30387 20.0311C9.65335 19.5033 9.94562 18.9398 10.1757 18.3502C10.213 18.2552 10.2181 18.1506 10.1904 18.0524C10.1626 17.9542 10.1035 17.8678 10.022 17.8064C8.71418 16.8164 7.99512 15.487 7.99512 14.0658Z",
    fill: "#667085"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20635_77348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIcon);
export default __webpack_public_path__ + "static/media/commentIcon.bb796ce659b5aa719af495305e69317e.svg";
export { ForwardRef as ReactComponent };